const MARKDOWN_EXTENSIONS = new Set(["md", "markdown"])

export const DELIVERABLE_PATH = "/deliverable.md"
export const PLAN_PATH = "/plan.md"

// Archived per-turn artifacts written when a new user message starts a fresh
// turn. They render with the same format-aware viewers as the active turn's
// /plan.md and /deliverable.md.
const ARCHIVED_DELIVERABLE_RE = /^\/deliverable-\d+\.md$/
const ARCHIVED_PLAN_RE = /^\/plan-\d+\.md$/

export function isDeliverableFile(path: string): boolean {
  return (
    path === DELIVERABLE_PATH || path === "deliverable.md" || ARCHIVED_DELIVERABLE_RE.test(path)
  )
}

export function isPlanFile(path: string): boolean {
  return path === PLAN_PATH || path === "plan.md" || ARCHIVED_PLAN_RE.test(path)
}

export function getFileExtension(path: string): string {
  const filename = path.split("/").pop() ?? path
  if (!filename.includes(".")) return ""
  return filename.split(".").pop()?.toLowerCase() ?? ""
}

export function isMarkdownFile(path: string): boolean {
  return MARKDOWN_EXTENSIONS.has(getFileExtension(path))
}

// Tool-call results live at paths like `call_<id>` (no extension). Their
// content is a JSON blob we can render with structure rather than as a wall
// of text. Also trigger on content that parses as JSON just in case.
export function looksLikeToolResult(path: string, content: string): boolean {
  const filename = path.split("/").pop() ?? path
  if (filename.startsWith("call_")) return true
  const trimmed = content.trimStart()
  return trimmed.startsWith("{") || trimmed.startsWith("[")
}
